import React from "react";
import deleteIcon from "../../assets/img/compact-menu-delete.png";
import editIcon from "../../assets/img/compact-menu-edit.png";
import reportsIcon from "../../assets/img/report-nav-icon.png";
import greenCircle from "../../assets/img/green-circle.png";
import dots from "../../assets/img/dots.png";
import "../../styles/css/ConnectionForm.css";

const Connection = (props) => {

    const editClick = (id) => {
        let projectId = new URLSearchParams(window.location.search).get("projectId");
        window.location.href = "/connection/form?projectId="+projectId+"&id="+id;
    };

    const reportsClick = (id) => {
        let projectId = new URLSearchParams(window.location.search).get("projectId");
        window.location.href = "/reports?projectId="+projectId+"&dcid="+id;
    };

    const renderActions = (id, connName) => {
        if (JSON.parse(localStorage.getItem('user')).role === "ADMIN"){
            return(
                <div className="compact-menu-connection">
                    <img src={dots} alt="dots" className="compact-menu-connection-dots"/>
                    <div className="compact-menu-connection-content">
                        <ul>
                            <li onClick={() => reportsClick(id)}>
                                <div>
                                    <img src={reportsIcon} alt="reports"/>
                                    <span style={{fontSize: "13px"}}>Reports</span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => editClick(id)}>
                                    <img src={editIcon} alt="edit"/>
                                    <span style={{fontSize: "13px"}}>Edit</span>
                                </div>
                            </li>
                            <li onClick={() => props.preDeleteConnection(id, connName)}>
                                <div>
                                    <img src={deleteIcon} alt="delete"/>
                                    <span style={{fontSize: "13px"}}>Delete</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            );
        }
    };

    return(
        <div id="connectionListItem">
            <div style={{width: "100%", marginRight: "70px", padding: "12px 10px"}}>
                <img src={greenCircle} style={{width: "16px", height: "16px", marginRight: "10px"}}/>
                <span id="connectionItemHeader" title={props.connection.databaseConnectionName}>
                    {props.connection.databaseConnectionName}
                </span>
            </div>
            {renderActions(props.connection.id, props.connection.databaseConnectionName)}
        </div>
    );
}

export default Connection;
